import React, { Component } from "react";

import { CButton, CCol, CRow } from "@coreui/react";
import {
  RiAttachmentLine,
  RiCheckboxCircleLine,
  RiCloseCircleLine,
  RiErrorWarningLine,
  RiFileList2Line,
  RiGroupFill,
  RiTeamFill,
  RiArticleLine,
  RiBillLine,
  RiDashboardFill,
  RiBillFill,
  RiArticleFill,
  RiDatabase2Fill,
  RiDossierLine,
  RiBookOpenLine,
  RiInformationLine
} from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import ImgNoData from "../../../assets/imgs/graduation.svg";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import { isToday } from "../../../utils/date";
import DashboardListItem from "../../DashboardListItem";
import Loading from "../../Loading";
import SwitchButton from "../../SwitchButton";

class LegacyProfessorDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboard: {
        cards: {},
        schedule: null,
        today: null,
        classrooms: [],
        rooms: []
      },
      current: null,
      // days: [],
      // events: [],
      primaryColor: null,
      secondaryColor: null,
      grayColor: null
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    axios
      .get(`${URL.api}general/dashboard/user`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          const classrooms = resp.data.data.classrooms.map(room => {
            const activities = resp.data.data.activities.filter(
              activity =>
                activity.room_id === room.id &&
                (!activity.class ||
                  activity.user_id === this.props.user.user.id)
            );
            return {
              ...room,
              activities_new: 0,
              activities_pending: activities.filter(
                activity =>
                  activity.activity_percentage < 100 &&
                  new Date(activity.activity_end) >= new Date() &&
                  activity.user_id !== this.props.user.user.id
              ).length,
              activities_late: activities.filter(
                activity =>
                  activity.activity_percentage < 100 &&
                  new Date(activity.activity_end) < new Date() &&
                  activity.user_id !== this.props.user.user.id
              ).length
            };
          });

          this.setState({
            raw: {
              ...resp.data.data,
              activities: resp.data.data.activities.filter(
                activity =>
                  !activity.class ||
                  activity.user_id === this.props.user.user.id
              )
            },
            dashboard: {
              schedule: this.group(
                resp.data.data.notices,
                resp.data.data.activities.filter(
                  activity =>
                    !activity.class ||
                    activity.user_id === this.props.user.user.id
                )
              ),
              rooms: resp.data.data.rooms,
              classrooms
            }
          });
        },
        error => {
          // eslint-disable-next-line no-console
          console.log("Não foi possível se comunicar com a plataforma!");
        }
      );

    const id = this.props.general.active_roles.group_id;
    if (id != null) {
      axios
        .get(`${URL.api}access/group/singleView/${id}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(respmodule => {
          this.setState(() => ({
            primaryColor: respmodule.data.data.group.primary,
            secondaryColor: respmodule.data.data.group.secondary,
            grayColor: respmodule.data.data.group.primary_grey
          }));
        });
    }
  }

  getEvents() {
    const { activities } = this.state.raw;
    const today = this.state.current;

    const events = activities.filter(activity => {
      if (
        isToday(new Date(activity.activity_start), this.state.current) ||
        isToday(new Date(activity.activity_end), this.state.current) ||
        (new Date(activity.activity_start) < this.state.current &&
          new Date(activity.activity_end) > this.state.current)
      ) {
        return true;
      }

      return false;
    });
    /* .map(activity => ({
      start: new Date(activity.activity_start),
      end: new Date(activity.activity_end),
      title: activity.name,
      resource: activity.type_id === 2 ? ("activity/live/" + activity.allocation_id) : ("activity/do/" + activity.allocation_id)
    })) */

    return events;
  }

  goBackWeek() {
    this.setState(
      state => ({
        current: new Date(state.current.valueOf() - 7 * 86400000)
      }),
      () => {
        this.updateDate();
      }
    );
  }

  goForwardWeek() {
    this.setState(
      state => ({
        current: new Date(state.current.valueOf() + 7 * 86400000)
      }),
      () => {
        this.updateDate();
      }
    );
  }

  updateDate() {
    const today = this.state.current.getDay();
    const firstDay = new Date(this.state.current.valueOf() - today * 86400000);
    const monthNames = [
      "JAN",
      "FEV",
      "MAR",
      "ABR",
      "MAI",
      "JUN",
      "JUL",
      "AGO",
      "SET",
      "OUT",
      "NOV",
      "DEZ"
    ];
    const weekDay = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"];
    const arr = [];

    for (let i = 0; i < 7; i++) {
      const day = new Date(firstDay.valueOf() + i * 86400000);

      arr.push({
        day: day.getDate(),
        month: monthNames[day.getMonth()],
        weekDay,
        today: day.getTime() === this.state.current.getTime(),
        date: day
      });
    }

    this.setState({
      // days: arr,
      // events: this.getEvents()
    });
  }

  getBorder(item) {
    if (item.activity_percentage) return "light";
    if (Date.parse(item.activity_end) < Date.now()) return "danger";
    return "primary";
  }

  group(notices, activities) {
    let months = [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez"
    ];
    let days = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

    // let myArray = [...notices, ...activities];
    let myArray = [...activities];

    myArray.sort((a, b) => {
      let c = new Date(a.activity_start ? a.activity_start : a.created_at);
      let d = new Date(b.activity_start ? b.activity_start : b.created_at);
      return d - c;
    });

    let groups = myArray.reduce((r, o) => {
      if (o.activity_start) {
        o = { ...o, activity: true };
      } else {
        o = { ...o, activity: false };
      }

      const dt = new Date(o.activity_start ? o.activity_start : o.created_at);

      let m = `${days[dt.getDay()]}/${`00${dt.getDate()}`.slice(-2)}/${
        months[dt.getMonth()]
      }/${dt.getFullYear()}`;
      r[m] ? r[m].data.push(o) : (r[m] = { group: m, data: [o] });
      return r;
    }, {});

    let result = Object.keys(groups).map(k => groups[k]);

    return result;
  }

  friendlyDate(date) {
    const dt = new Date(date);

    return `${`00${dt.getDate()}`.slice(-2)}/${`00${dt.getMonth() + 1}`.slice(
      -2
    )} ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(-2)}`;
  }

  getShortcuts() {
    const modules =
      this.props.user.user_modules?.map(module => module.id) || [];

    const isCompletePlatform = modules.includes(2);
    const isQuestionsPlatform = modules.includes(3);
    const isBooksPlatform = modules.includes(11);

    let isConstruir =
      this.props.general.active_roles.group_id === 45 ||
      this.props.general.active_roles.group_id === 92;
    if (isConstruir) {
      return [
        {
          url: "content/list/0",
          color: "#86C3D7",
          icon: RiDashboardFill,
          text: "Recursos"
        }
      ];
    }
    if (isCompletePlatform) {
      return [
        {
          url: "classroom/me",
          color: "#988FE9",
          icon: RiGroupFill,
          text: "Minhas turmas"
        },
        {
          url: "room/me",
          color: "#00BE90",
          icon: RiTeamFill,
          text: "Minhas comunidades"
        },
        {
          url: "activity/create",
          color: "#5187A2",
          icon: RiArticleLine,
          text: "Criar atividade"
        },
        {
          url: "evaluation/create",
          color: "#EFC261",
          icon: RiBillLine,
          text: "Criar avaliação"
        },
        {
          url: "activity/list",
          color: "#C99678",
          icon: RiArticleFill,
          text: "Visualizar atividades"
        },
        {
          url: "evaluation/list",
          color: "#80A1A3",
          icon: RiBillFill,
          text: "Visualizar avaliações"
        },
        {
          url: "question/bank",
          color: "#E36767",
          icon: RiDatabase2Fill,
          text: "Banco de questões"
        },
        {
          url: "content/list/0",
          color: "#86C3D7",
          icon: RiDashboardFill,
          text: "Recursos"
        }
      ];
    }
    if (isBooksPlatform) {
      return [
        {
          url: "library",
          color: "#6f42c1",
          icon: RiBookOpenLine,
          text: "Biblioteca"
        },
        {
          url: "classroom/me",
          color: "#988FE9",
          icon: RiGroupFill,
          text: "Minhas turmas"
        },
        {
          url: "activity/create",
          color: "#5187A2",
          icon: RiArticleLine,
          text: "Criar atividade"
        },
        {
          url: "activity/list",
          color: "#C99678",
          icon: RiArticleFill,
          text: "Visualizar atividades"
        },
        {
          url: "docs/me",
          color: "#EFC261",
          icon: RiAttachmentLine,
          text: "Meus documentos"
        },
        {
          url: "room/me",
          color: "#00BE90",
          icon: RiTeamFill,
          text: "Minhas comunidades"
        },
        {
          url: "requests",
          color: "#E36767",
          icon: RiDossierLine,
          text: "Minhas solicitações"
        },
        {
          url: "faq",
          color: "#80A1A3",
          icon: RiInformationLine,
          text: "FAQ"
        }
      ];
    }
    if (isQuestionsPlatform) {
      return [
        {
          url: "classroom/me",
          color: "#988FE9",
          icon: RiGroupFill,
          text: "Minhas turmas"
        },
        {
          url: "room/me",
          color: "#00BE90",
          icon: RiTeamFill,
          text: "Minhas comunidades"
        },
        {
          url: "activity/create",
          color: "#5187A2",
          icon: RiArticleLine,
          text: "Criar atividade"
        },
        {
          url: "evaluation/create",
          color: "#EFC261",
          icon: RiBillLine,
          text: "Criar avaliação"
        },
        {
          url: "activity/list",
          color: "#C99678",
          icon: RiArticleFill,
          text: "Visualizar atividades"
        },
        {
          url: "evaluation/list",
          color: "#80A1A3",
          icon: RiBillFill,
          text: "Visualizar avaliações"
        },
        {
          url: "question/bank",
          color: "#E36767",
          icon: RiDatabase2Fill,
          text: "Banco de questões"
        },
        {
          url: "requests",
          color: "#E36767",
          icon: RiDossierLine,
          text: "Minhas solicitações"
        }
      ];
    }

    return [];
  }

  render() {
    let isConstruir =
      this.props.general.active_roles.group_id === 45 ||
      this.props.general.active_roles.group_id === 92;
    const { schedule } = this.state.dashboard;
    const root = document.documentElement;

    root?.style.setProperty(
      "--primary-group-change",
      this.state.primaryColor != null ? this.state.primaryColor : ""
    );
    root?.style.setProperty(
      "--secondary-group-change",
      this.state.secondaryColor != null ? this.state.secondaryColor : ""
    );
    root?.style.setProperty(
      "--primary-grey-group-change",
      this.state.grayColor != null ? this.state.grayColor : ""
    );

    return (
      <div className="w-100">
        <CRow className=" mb-3">
          <CCol xs="12" lg="5">
            <div className="w-100">
              <div className="d-flex align-items-center mb-3">
                <h2 className="font-weight-bold text-title mb-0">Atalhos</h2>
              </div>
              <CRow>
                {this.getShortcuts().map((shortcut, index) => (
                  <CCol xs="6" className="mb-3 d-flex">
                    <CButton
                      color="white"
                      onClick={() => this.props.history.push(shortcut.url)}
                      className="p-0 h-100 border-default rounded-lg d-flex flex-column justify-content-center align-items-center"
                      block
                      style={{ fontSize: "1.125rem", width: "12rem" }}
                    >
                      <div
                        className="p-4 flex-1 text-center w-100"
                        style={{
                          minWidth: "100%",
                          backgroundColor: shortcut.color,
                          borderRadius: "inherit",
                          borderBottomLeftRadius: 0,
                          borderBottomRightRadius: 0
                        }}
                      >
                        <shortcut.icon size={48} color="white" />
                      </div>
                      <div className="p-3 text-title h-100 d-flex align-items-center">
                        {shortcut.text}
                      </div>
                    </CButton>
                  </CCol>
                ))}
              </CRow>
            </div>
          </CCol>
          {!isConstruir && (
            <CCol xs="12" lg="7" className="d-flex flex-column">
              <h2 className="font-weight-bold text-title mb-3">Agenda</h2>
              <div className="d-flex flex-wrap mb-3">
                <SwitchButton
                  text="Todas"
                  icon={<RiFileList2Line />}
                  className="mr-3 mb-2"
                  onClick={() =>
                    this.setState(state => ({
                      dashboard: {
                        ...state.dashboard,
                        schedule: this.group(
                          state.raw.notices,
                          state.raw.activities
                        )
                      }
                    }))
                  }
                />
                <SwitchButton
                  text="A fazer"
                  icon={<RiErrorWarningLine />}
                  className="mb-2 mr-3"
                  onClick={() =>
                    this.setState(state => ({
                      dashboard: {
                        ...state.dashboard,
                        schedule: this.group(
                          state.raw.notices,
                          state.raw.activities.filter(
                            activity =>
                              activity.activity_percentage < 100 &&
                              new Date(activity.activity_end) >= new Date() &&
                              activity.user_id !== this.props.user.user.id
                          )
                        )
                      }
                    }))
                  }
                />
                <SwitchButton
                  text="Não realizadas"
                  icon={<RiCloseCircleLine />}
                  className="mb-2 mr-3"
                  onClick={() =>
                    this.setState(state => ({
                      dashboard: {
                        ...state.dashboard,
                        schedule: this.group(
                          state.raw.notices,
                          state.raw.activities.filter(
                            activity =>
                              activity.activity_percentage < 100 &&
                              new Date(activity.activity_end) < new Date() &&
                              activity.user_id !== this.props.user.user.id
                          )
                        )
                      }
                    }))
                  }
                />
                <SwitchButton
                  text="Concluídas"
                  icon={<RiCheckboxCircleLine />}
                  className="mb-2"
                  onClick={() =>
                    this.setState(state => ({
                      dashboard: {
                        ...state.dashboard,
                        schedule: this.group(
                          state.raw.notices,
                          state.raw.activities.filter(
                            activity =>
                              activity.activity_percentage >= 100 &&
                              activity.user_id !== this.props.user.user.id
                          )
                        )
                      }
                    }))
                  }
                />
              </div>
              <div
                className="flex-1"
                style={{
                  minHeight: "492px",
                  maxHeight: "60vh",
                  overflowY: "auto"
                }}
              >
                <div>
                  {schedule ? (
                    schedule.length > 0 ? (
                      schedule.map((day, index) => (
                        <div key={index}>
                          <h5 className="text-title font-weight-semibold">
                            {day.group.split("/")[0]},{" "}
                            {`${day.group.split("/")[1]} ${
                              day.group.split("/")[2]
                            }${
                              parseInt(day.group.split("/")[3]) ===
                              new Date().getFullYear()
                                ? ""
                                : ` ${day.group.split("/")[3]}`
                            }`}
                          </h5>
                          <div className="my-3">
                            <div className="mb-4">
                              {day.data.map(item => (
                                <DashboardListItem
                                  item={item}
                                  key={item.id}
                                  className="mb-3"
                                />
                              ))}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="justify-content-center align-items-center d-flex flex-column my-5">
                        <img
                          src={ImgNoData}
                          style={{ height: "240px", marginBottom: "2rem" }}
                          alt=""
                        />
                        <p
                          style={{ fontSize: "1.5rem" }}
                          className="mb-2 font-weight-bold text-center"
                        >
                          Você ainda não tem nenhuma atividade
                        </p>
                        <span className="text-muted text-center">
                          Acesse os recursos da plataforma através dos menus
                          laterais
                        </span>
                      </div>
                    )
                  ) : (
                    <div className="p-4">
                      <Loading />
                    </div>
                  )}
                </div>
              </div>
            </CCol>
          )}
        </CRow>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LegacyProfessorDashboard);
